import React from 'react';

export function CodexStrip({ ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 1440 21"
      {...props}
    >
      <g clipPath="url(#clip0_9_29)">
        <path fill="#fff" d="M0 0H1440V21H0z" />
        <path fill="#0E2B63" d="M0 0H432V21H0z" />
        <path fill="#004F9F" d="M0 0H316.8V21H0z" transform="translate(432)" />
        <path
          fill="#00B1EB"
          d="M0 0H187.2V21H0z"
          transform="translate(748.8)"
        />
        <path fill="#EF7D00" d="M0 0H122.4V21H0z" transform="translate(936)" />
        <path fill="#FB0" d="M0 0H93.6V21H0z" transform="translate(1058.4)" />
        <path fill="#50AF47" d="M0 0H100.8V21H0z" transform="translate(1152)" />
        <path fill="#AFCA0B" d="M0 0H72V21H0z" transform="translate(1252.8)" />
        <path fill="#5A328A" d="M0 0H72V21H0z" transform="translate(1324.8)" />
        <path
          fill="#E72582"
          d="M0 0H43.2V21H0z"
          transform="translate(1396.8)"
        />
      </g>
      <defs>
        <clipPath id="clip0_9_29">
          <path fill="#fff" d="M0 0H1440V21H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
